import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { ref, onValue, push, set, get, update } from "firebase/database";
import { ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase";

import { auth, db } from "../firebase";
import { useTranslation } from "react-i18next";


const MarketChat = () => {
  const { chatId } = useParams();
  const [chatInfo, setChatInfo] = useState(null);
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
const [order, setOrder] = useState(null);
const { t } = useTranslation();
const [receiptFile, setReceiptFile] = useState(null);
const [cashDepositMode, setCashDepositMode] = useState(false);
const [paymentFullName, setPaymentFullName] = useState("");
const [paymentPhone, setPaymentPhone] = useState("");
const [paymentReference, setPaymentReference] = useState("");
const [currentUser, setCurrentUser] = useState(null);
useEffect(() => {
  const unsub = auth.onAuthStateChanged((user) => {
    setCurrentUser(user);
  });






  return () => unsub();
}, []);

const isBuyer = currentUser?.uid === order?.buyerId;
const isSeller = currentUser?.uid === order?.sellerId;



  const bottomRef = useRef(null);

const paymentBtnStyle = {
  minWidth: "88px",
  maxWidth: "105px",
  padding: "8px 9px",
  border: "none",
  borderRadius: "10px",
  background: "#0a4ecc",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer",
  fontSize: "11px",
  whiteSpace: "nowrap",
  textAlign: "center",
  boxShadow: "0 0 8px rgba(10,78,204,0.28)",
};

const handleSellerAcceptOrder = async () => {
  if (!order) return;

  await update(ref(db, `marketOrders/${order.orderId}`), {
    sellerAccepted: true,
    orderStatus: "seller_accepted",
    updatedAt: Date.now(),
  });
};

const handleBuyerConfirmPayment = async (selectedProvider) => {  
  if (!order) return;



if (selectedProvider === "cash") {
  setCashDepositMode(true);
  return;
}



try {
  const response = await fetch(
    "http://localhost:5000/create-market-payment",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },

      body: JSON.stringify({
        orderId: order.orderId,
        buyerId: order.buyerId,
        sellerId: order.sellerId,
        amount: order.amount,
        itemTitle: order.itemTitle,
        country:
          order.destinationCountry ||
          "Papua New Guinea",

        selectedProvider,
      }),
    }
  );

  const data = await response.json();


  

 const checkoutUrl =
  data.checkoutUrl ||
  data.paymentLink ||
  data.url ||
  data.checkout_url;

if (checkoutUrl) {
  window.location.href = checkoutUrl;
} else {
  console.log("Payment response:", data);
  alert("Payment checkout could not be created. Check backend provider support.");
}


} catch (error) {
  console.error(error);
alert(t("payment_failed_start"));  
}
};

const handleAssignKinaTripDriver = async () => {
  if (!order || !chatInfo) return;

  const deliveryId = `DELIVERY-${Date.now()}`;

  await set(ref(db, `marketDeliveries/${deliveryId}`), {
    deliveryId,

    orderId: order.orderId,
    chatId,

    itemTitle: order.itemTitle,
    amount: order.amount,

    buyerId: order.buyerId,
    sellerId: order.sellerId,

   pickupLocation:
  order.pickupLocation || t("seller_location"),

    dropoffLocation:
  order.dropoffLocation || t("buyer_location"),

    deliveryStatus: "waiting_driver",

    createdAt: Date.now(),
  });

  await update(
    ref(db, `marketOrders/${order.orderId}`),
    {
      driverAssigned: true,
      deliveryStatus: "waiting_driver",
      orderStatus: "waiting_driver_acceptance",
      deliveryId,
      updatedAt: Date.now(),
    }
  );
};

const handleBuyerConfirmReceived = async () => {
  if (!order) return;

  await update(ref(db, `marketOrders/${order.orderId}`), {
    buyerReceived: true,
    deliveryStatus: "delivered",
    orderStatus: "buyer_confirmed_received",
    updatedAt: Date.now(),
  });
};

const handleReleaseEscrow = async () => {
  if (!order) return;

  await update(ref(db, `marketOrders/${order.orderId}`), {
    escrowReleased: true,
    escrowStatus: "released",
    orderStatus: "completed",
    updatedAt: Date.now(),
  });
};






  useEffect(() => {
    const chatRef = ref(db, `marketChats/${chatId}`);
    const messagesRef = ref(db, `marketChatMessages/${chatId}`);
    const unsubChat = onValue(chatRef, (snap) => {
      setChatInfo(snap.val() || null);
    });

    const unsubMessages = onValue(messagesRef, (snap) => {
      const data = snap.val() || {};
      const list = Object.entries(data)
        .map(([id, msg]) => ({ id, ...msg }))
        .sort((a, b) => Number(a.createdAt || 0) - Number(b.createdAt || 0));
      setMessages(list);
    });

    return () => {
      unsubChat();
      unsubMessages();
    };
  }, [chatId]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);


useEffect(() => {
  const orderRef = ref(db, "marketOrders");

  const unsubscribe = onValue(orderRef, (snap) => {
    const data = snap.val() || {};

    const foundOrder = Object.values(data).find(
      (o) => o.chatId === chatId
    );

    if (foundOrder) {
      setOrder(foundOrder);
    }
  });

  return () => unsubscribe();
}, [chatId]);




  const sendMessage = async () => {
    const currentUser = auth.currentUser;
    if (!currentUser || !text.trim()) return;

let senderName = t("user");    
    const passengerSnap = await get(ref(db, `passengers/${currentUser.uid}`));
    const driverSnap = await get(ref(db, `drivers/${currentUser.uid}`));

    if (passengerSnap.exists()) senderName = passengerSnap.val().name || t("user")

    else if (driverSnap.exists()) senderName = driverSnap.val().name || t("user")

    const msgRef = push(ref(db, `marketChatMessages/${chatId}`));
    await set(msgRef, {
      senderId: currentUser.uid,
      senderName,
      text: text.trim(),
      createdAt: Date.now(),
      type: "text",
    });

    setText("");
  };

  if (!chatInfo) {
return (
  <div style={{ padding: "20px" }}>
    {t("loading_chat")}
  </div>
);    
  }




  return (


    <div style={{ height: "100vh", display: "flex", flexDirection: "column", background: "#f6f7fb" }}>
      <div style={{ padding: "14px", background: "#0a4ecc", color: "#fff", fontWeight: "bold" }}>
        <div>{chatInfo.sellerName}</div>
        <div style={{ fontSize: "12px", opacity: 0.9 }}>
          {chatInfo.itemTitle} - K{Number(chatInfo.itemPrice || 0)}
        </div>
      </div>

      <div style={{ padding: "12px", background: "#fff", borderBottom: "1px solid #eee" }}>
        {chatInfo.itemImage && (
          <img
            src={chatInfo.itemImage}
            alt="Item"
            style={{ width: "90px", height: "90px", objectFit: "cover", borderRadius: "10px" }}
          />
        )}
      </div>


{order && (
  <div style={{
    background: "#fff",
    padding: "12px",
    borderBottom: "1px solid #eee"
  }}>
   <div style={{ fontWeight: "bold", color: "#111" }}>
  {order.itemTitle}
</div>

    <div style={{ marginTop: "5px", color: "#111" }}>
{t("amount")}: K{order.amount}      
    </div>

   <div style={{ marginTop: "5px", color: "#111" }}>
{t("payment")}: {order.paymentStatus}  
</div>

<div style={{ color: "#111" }}>
{t("delivery")}: {order.deliveryStatus}  
</div>
  </div>
)}


{order && (
  <div
    style={{
      background: "#f8f9ff",
      padding: "10px",
      borderBottom: "1px solid #ddd",
      display: "flex",
      flexWrap: "wrap",
      gap: "6px",
    }}
  >
    <div
      style={{
        padding: "6px 10px",
        borderRadius: "20px",
        background:
          order.orderStatus === "waiting_seller_acceptance"
            ? "#0878f8"
            : "#ff4757",
        color: "#fff",
        fontSize: "12px",
      }}
    >
{t("seller_review")}      
    </div>

    <div
      style={{
        padding: "6px 10px",
        borderRadius: "20px",
        background:
          order.orderStatus === "seller_accepted"
            ? "#2196f3"
           : "#ff4757",
        color: "#fff",
        fontSize: "12px",
      }}
    >
{t("awaiting_payment")}      
    </div>

    <div
      style={{
        padding: "6px 10px",
        borderRadius: "20px",
        background:
          order.orderStatus === "paid_waiting_driver"
            ? "#9c27b0"
            : "#ff4757",
        color: "#fff",
        fontSize: "12px",
      }}
    >
{t("escrow_holding")}      
    </div>

    <div
      style={{
        padding: "6px 10px",
        borderRadius: "20px",
        background:
  order.orderStatus === "waiting_seller_acceptance"
    ? "#0a4ecc"
    : "#ff4757",
color: "#fff",
        fontSize: "12px",
      }}
    >
{t("driver_assigned")}      
    </div>

    <div
      style={{
        padding: "6px 10px",
        borderRadius: "20px",
        background:
          order.orderStatus === "buyer_confirmed_received"
            ? "#4caf50"
           : "#ff4757",
        color: "#fff",
        fontSize: "12px",
      }}
    >
{t("delivered")}      
    </div>

    <div
      style={{
        padding: "6px 10px",
        borderRadius: "20px",
        background:
          order.orderStatus === "completed"
            ? "#2e7d32"
            : "#ff4757",
        color: "#fff",
        fontSize: "12px",
      }}
    >
{t("escrow_released")}      
    </div>
  </div>
)}






{isSeller &&
 order?.orderStatus === "waiting_seller_acceptance" && (  
 <button
  onClick={handleSellerAcceptOrder}
  style={{
    width: "100%",
    padding: "12px",
    border: "none",
    borderRadius: "10px",
    background: "#0a4ecc",
    color: "#fff",
    fontWeight: "bold",
    cursor: "pointer",
    marginTop: "10px",
  }}
>
  {t("accept_order")}
</button>
)}

{isBuyer &&
 order?.orderStatus === "seller_accepted" && (  
<div
  style={{
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    justifyContent: "center",
    marginTop: "10px",
  }}
>
  <button
    onClick={() => handleBuyerConfirmPayment("stripe")}
    style={{
      ...paymentBtnStyle,
      background: "#635bff",
    }}
  >
💳 {t("stripe")}    
  </button>

  <button
    onClick={() => handleBuyerConfirmPayment("flutterwave")}
    style={{
      ...paymentBtnStyle,
      background: "#ff7a00",
    }}
  >
    🌍 {t("flutterwave")}
  </button>

  <button
    onClick={() => handleBuyerConfirmPayment("xendit")}
    style={{
      ...paymentBtnStyle,
      background: "#00b14f",
    }}
  >
🇮🇩 {t("xendit")}
  </button>

  <button
    onClick={() => handleBuyerConfirmPayment("paypal")}
    style={{
      ...paymentBtnStyle,
      background: "#0070ba",
    }}
  >
🅿️ {t("paypal")}    
  </button>

  <button
    onClick={() => handleBuyerConfirmPayment("cash")}
    style={{
      ...paymentBtnStyle,
      background: "#2e7d32",
    }}
  >
💵 {t("cash")}    
  </button>
</div>
)}


{cashDepositMode && (
  <div
    style={{
      margin: "12px",
      padding: "14px",
      background: "#fff",
      borderRadius: "14px",
      border: "1px solid #ddd",
      boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
    }}
  >
    <h4 style={{ color: "#2e7d32", marginBottom: "10px" }}>
💵 {t("cash_deposit_verification")}      
    </h4>

    <p style={{ fontSize: "12px", color: "#555" }}>
{t("deposit_instruction")}      
    </p>

    <input
placeholder={t("full_name")}      
      value={paymentFullName}
      onChange={(e) =>
        setPaymentFullName(e.target.value)
      }
      style={{
        width: "100%",
        padding: "10px",
        marginBottom: "8px",
        borderRadius: "10px",
        border: "1px solid #ccc",
      }}
    />

    <input
placeholder={t("phone_number")}      
      value={paymentPhone}
      onChange={(e) =>
        setPaymentPhone(e.target.value)
      }
      style={{
        width: "100%",
        padding: "10px",
        marginBottom: "8px",
        borderRadius: "10px",
        border: "1px solid #ccc",
      }}
    />

    <input
placeholder={t("receipt_reference")}      
      value={paymentReference}
      onChange={(e) =>
        setPaymentReference(e.target.value)
      }
      style={{
        width: "100%",
        padding: "10px",
        marginBottom: "8px",
        borderRadius: "10px",
        border: "1px solid #ccc",
      }}
    />

<input
  type="file"
  accept="image/*,.pdf"
  onChange={(e) => setReceiptFile(e.target.files[0])}
  style={{
    width: "100%",
    marginBottom: "10px",
    fontSize: "11px",
  }}
/>


    <button
      onClick={async () => {
        if (
          !paymentFullName ||
          !paymentPhone ||
          !paymentReference
        ) {
alert(t("complete_all_fields"));          
          return;
        }

if (!receiptFile) {
alert(t("please_upload_receipt"));  
  return;
}

const fileRef = storageRef(
  storage,
  `marketReceipts/${order.orderId}/${Date.now()}-${receiptFile.name}`
);

await uploadBytes(fileRef, receiptFile);

const receiptUrl = await getDownloadURL(fileRef);


        await update(
          ref(db, `marketOrders/${order.orderId}`),
          {

            receiptUrl,
            paymentProvider: "cash",
            paymentStatus: "manual_pending",
            orderStatus: "cash_deposit_pending",
            escrowStatus: "manual_review",

            payerName: paymentFullName,
            payerPhone: paymentPhone,
            bankReference: paymentReference,

            updatedAt: Date.now(),
          }
        );
      
       alert(t("cash_deposit_success"));


        setCashDepositMode(false);
      }}
      style={{
        width: "100%",
        padding: "12px",
        border: "none",
        borderRadius: "10px",
        background: "#2e7d32",
        color: "#fff",
        fontWeight: "bold",
        cursor: "pointer",
      }}
    >
{t("submit_cash_deposit")}      
    </button>
  </div>
)}




{isSeller &&
 order?.orderStatus === "paid_waiting_driver" && (  
  <button onClick={handleAssignKinaTripDriver}>
{t("assign_kinatrip_driver")}    
  </button>
)}

{isBuyer &&
 order?.orderStatus === "delivery_assigned" && (  
  <button onClick={handleBuyerConfirmReceived}>
{t("buyer_confirm_received")}    
  </button>
)}

{isSeller &&
 order?.orderStatus === "buyer_confirmed_received" && (  
  <button onClick={handleReleaseEscrow}>
{t("release_escrow_to_seller")}    
  </button>
)}


      <div style={{ flex: 1, overflowY: "auto", padding: "14px" }}>
        {messages.map((msg) => {
          const mine = msg.senderId === auth.currentUser?.uid;





          return (
            <div
              key={msg.id}
              style={{
                display: "flex",
                justifyContent: mine ? "flex-end" : "flex-start",
                marginBottom: "10px",
              }}



            >
              <div
                style={{
                  maxWidth: "75%",
                  background: mine ? "#0a4ecc" : "#fff",
                  color: mine ? "#fff" : "#222",
                  padding: "10px 12px",
                  borderRadius: "12px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                }}
              >
                <div style={{ fontSize: "12px", fontWeight: "bold", marginBottom: "4px" }}>
                  {msg.senderName}
                </div>
                <div>{msg.text}</div>
              </div>
            </div>
          );
        })}
        <div ref={bottomRef} />
      </div>

      <div style={{ display: "flex", gap: "10px", padding: "12px", background: "#fff", borderTop: "1px solid #eee" }}>
        <input
          type="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
placeholder={t("type_message")}          
          style={{
            flex: 1,
            padding: "12px",
            borderRadius: "10px",
            border: "1px solid #ccc",
            outline: "none",
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") sendMessage();
          }}
        />
        <button
          onClick={sendMessage}
          style={{
            background: "#0a4ecc",
            color: "#fff",
            border: "none",
            borderRadius: "10px",
            padding: "12px 18px",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
{t("send")}          
        </button>
      </div>
    </div>
  );
};

export default MarketChat;